// Decides which per-row action buttons the sponsor sees in the passport unlock-request queue.
// Inbound requests (ones the sponsor decides) get action buttons; outbound requests (ones the
// sponsor or a candidate made) are read-only from here.
//
// Decided rows are reversible so managers can undo mistakes without the candidate re-submitting:
//   - pending  (0): Approve or Reject.
//   - approved (1): Reject (re-lock the named passport) or Reset to pending.
//   - rejected (2): Approve (reverse) or Reset to pending.
// Reset means "back to pending" (feedback 0), so it is never offered on an already-pending row.
// Reversals that reduce access (from approved) are guarded by a confirm at the call site.
//
// The kebab (MoreVert) menu is always available and is not represented here.
export const getPassportRowActions = (feedback, isOutbound) => {
  if (isOutbound) {
    return { showApprove: false, showReject: false, showReset: false };
  }

  switch (feedback) {
    case 0: // pending
      return { showApprove: true, showReject: true, showReset: false };
    case 1: // approved -> re-lock or reset to pending
      return { showApprove: false, showReject: true, showReset: true };
    case 2: // rejected -> reverse to approved or reset to pending
      return { showApprove: true, showReject: false, showReset: true };
    default:
      return { showApprove: false, showReject: false, showReset: false };
  }
};
